import type { Household } from './schemas';

/** Family Atmosphere: how the wall display rests (see schemas.ts → Household.atmosphere). */
export type Atmosphere = NonNullable<Household['atmosphere']>;

/** On by default: after 3 minutes without a touch, almost black from 22 to 6 o'clock. */
export const ATMOSPHERE_DEFAULTS: Atmosphere = {
  enabled: true,
  idleMinutes: 3,
  sleepFrom: '22:00',
  sleepTo: '06:00',
};

export type RestMode = 'ambient' | 'sleep';

/** Ambient by day, sleep inside the night window (which may cross midnight). */
export function restMode(time: string, a: Pick<Atmosphere, 'sleepFrom' | 'sleepTo'>): RestMode {
  const { sleepFrom: from, sleepTo: to } = a;
  if (!from || from === to) return 'ambient';
  const inside = from < to ? time >= from && time < to : time >= from || time < to;
  return inside ? 'sleep' : 'ambient';
}
